import { type RecentConversation } from '../../../value-objects/RecentConversation'
import { type IRecentConversationsRepository } from '../../interfaces/IRecentConversationsRepository'

const MAX_RECENT_CONVERSATIONS = 1

interface Dependency {
  recentConversationsRepository: IRecentConversationsRepository
}

export class AddRecentConversationUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (conversation: RecentConversation): void => {
    const otherConversations = this.deps.recentConversationsRepository
      .getAll()
      .filter(
        (candidate) => candidate.conversationId !== conversation.conversationId
      )

    this.deps.recentConversationsRepository.save(
      [conversation, ...otherConversations].slice(0, MAX_RECENT_CONVERSATIONS)
    )
  }
}
